import { auth } from '@mxa-argos/core/config/firebase';
import { onIdTokenChanged, signOut } from 'firebase/auth';

let isLoggingOut = false;

onIdTokenChanged(auth, () => {
  if (auth.currentUser) {
    isLoggingOut = false;
  }
});

export function isUserLoggingOut(): boolean {
  return isLoggingOut;
}

export function markLoggingOut(): void {
  isLoggingOut = true;
}

export async function forceLogout(): Promise<void> {
  if (isLoggingOut) return;
  isLoggingOut = true;
  await signOut(auth).finally(() => {
    window.location.href = '/login';
  });
}
